import * as React from "react";
import { action, observable, autorunAsync, computed } from "mobx";
import { observer, inject } from "mobx-react";
import { StateStorage } from "./StateStorage"
import { UiRepos } from "../Stores/UiStore";

export class PreviewStore {
	readonly PREVIEW_UI_INFO: string = "previewUiInfo";
	readonly READER_KEY: string = "reader";
	readonly FAVOURITES_KEY: string = "favourites";
	readonly RECENT_FILES_KEY: string = "recentFiles";

	@observable key: string;
	@observable reader: boolean = false;
	@observable favourites: boolean = false;
	@observable recentFiles: boolean = false;

	@computed get showPreviews(): boolean {
		switch (this.key) {
			case this.READER_KEY:
				return this.reader;
			case this.FAVOURITES_KEY:
				return this.favourites;
			case this.RECENT_FILES_KEY:
				return this.recentFiles;
			default:
				return false;
		}
	}

	set showPreviews(value) {
		switch (this.key) {
			case this.READER_KEY:
				this.reader = value;
				break;
			case this.FAVOURITES_KEY:
				this.favourites = value;
				break;
			case this.RECENT_FILES_KEY:
				this.recentFiles = value;
				break;
		}
	}

	constructor(key: string) {
		this.key = key;
	}

	loadSettings = () => {
		let previewUiInfo = StateStorage.getData(this.PREVIEW_UI_INFO);
		if (previewUiInfo) {
			let obj = JSON.parse(previewUiInfo);
			this.reader = obj[this.READER_KEY];
			this.favourites = obj[this.FAVOURITES_KEY];
			this.recentFiles = obj[this.RECENT_FILES_KEY];
		}
	}

	autoSave = autorunAsync(() => {
		StateStorage.saveData(this.PREVIEW_UI_INFO, JSON.stringify(this));
	});

	removePreviewUiSettings = () => {
		StateStorage.removeData(this.PREVIEW_UI_INFO);
	}
}